// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RedirectPage_wrapper__SjfgN"};